export const TELEGRAM_WEB_HOST = 'telegram.me'

export function getTelegramLink(username) {
  return `https://${TELEGRAM_WEB_HOST}/${username}`
}
